var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupDetailsEmbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7375 2.59961H2.2625C1.70331 2.59961 1.25 3.05292 1.25 3.61211V12.3871C1.25 12.9463 1.70331 13.3996 2.2625 13.3996H13.7375C14.2967 13.3996 14.75 12.9463 14.75 12.3871V3.61211C14.75 3.05292 14.2967 2.59961 13.7375 2.59961Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.61211C1.25 3.34358 1.35667 3.08604 1.54655 2.89616C1.73644 2.70628 1.99397 2.59961 2.2625 2.59961H13.7375C14.006 2.59961 14.2636 2.70628 14.4534 2.89616C14.6433 3.08604 14.75 3.34358 14.75 3.61211V6.64961H1.25V3.61211Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45117 4.62402C3.45117 4.52744 3.37293 4.44932 3.27637 4.44922C3.17972 4.44922 3.10156 4.52737 3.10156 4.62402C3.10167 4.72058 3.17978 4.79883 3.27637 4.79883C3.37286 4.79872 3.45107 4.72052 3.45117 4.62402Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47461 4.62402C5.47461 4.52744 5.39636 4.44932 5.2998 4.44922C5.20315 4.44922 5.125 4.52737 5.125 4.62402C5.12511 4.72058 5.20322 4.79883 5.2998 4.79883C5.3963 4.79872 5.4745 4.72052 5.47461 4.62402Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDetailsEmbed);
export default __webpack_public_path__ + "static/media/group_details_embed.8af525e3cd9cb5b6b837c862b9d73ea6.svg";
export { ForwardRef as ReactComponent };